import { Fragment } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { HeroDescription } from "components/atoms/Text";

const Hero = () => {
    return (
        <Fragment>
            <header className={clsx(
                "w-full max-w-[1440px] mx-auto relative top-8",
                "flex flex-col tablet:flex-row desktop:flex-row justify-between",
                "px-6 tablet:pl-8 desktop:pl-[120px]",
                "tablet:pr-2 desktop:pr-[56px] tablet:pb-[128px] pb-[96px] phone:mb-4 overflow-hidden"
            )}>
                <img src='/images/homepage/hero/blockpath.svg' className='absolute phone:hidden tablet:hidden desktop:hidden block tablet:-bottom-4 -bottom-10 -left-[-0.5rem] tablet:w-[200px]' width="324px" height="290px" alt="path" />
                <div className="w-full tablet:max-w-[440px] desktop:max-w-[555px] pt-[60px] phone:pt-[40px] phone:mt-[2px] tablet:pt-[102px] desktop:pt-[158px]">
                    <h1 title="heading-data-center" className="text-heading-1 phone:text-[32px] phone:leading-[48px] tablet:text-heading-2 desktop:text-display font-semibold text-basier-circle-semibold text-neutral-100">Global Datacenter Coverage</h1>
                    <HeroDescription title="subheading-data-center" classNames="desktop:!max-w-[500px]">
                        Our datacenters are spread across the globe and we're constantly refreshing our lists to ensure a rich set of countries and locations that you can chose from.
                    </HeroDescription>
                    <div className="w-full flex flex-col md:flex-row md:items-center md:space-x-6 space-y-4 md:space-y-0 phone:mt-8 tablet:mt-8 mt-10">
                        <a href="/auth/signin" className="relative z-20">
                            <button className="py-[18px] phone:w-full h-[56px] w-[170px] leading-[19.83px] flex items-center justify-center font-semibold rounded-lg bg-primary-main hover:bg-primary-hover text-md text-basier-circle-semibold text-neutral-10">Buy Proxy</button>
                        </a>
                        <Link to="/buy-vpn" className="">
                            <button className="py-[18px] phone:w-full h-[56px] w-[170px] leading-[19.83px] flex items-center justify-center font-semibold rounded-lg text-primary-main text-md text-basier-circle-semibold bg-primary-surface">Buy VPN</button>
                        </Link>
                    </div>
                </div>
                <div className="w-full relative phone:right-[-22px] tablet:max-w-[550px] tablet:max-h-[462px] desktop:max-w-[681px] max-w-[777px] tablet:pt-[68px] pt-[88px] phone:pt-[72px] pl-[14px]">
                    <img src="/images/datacenter/hero.png" className='phone:scale-[1.27] desktop:scale-[1.03] tablet:absolute tablet:right-[-3.25rem] desktop:h-[572px] desktop:w-[681px] tablet:top-[38px]' width="777px" height="567px" alt="proxy-hero" />
                </div>
            </header>
        </Fragment>
    );
};

export default Hero;